/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import jwtDecode from 'jwt-decode';

type DecodedTokenType = Record<string, string | Array<string> | number>;

export const useAuthExpiration = () => {
  const { isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const [isTokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    const checkTokenExpiration = async () => {
      try {
        const token = await getAccessTokenSilently();
        const decodedToken: DecodedTokenType = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        if (typeof decodedToken['exp'] === 'number' && decodedToken['exp'] < currentTime) {
          logout({ logoutParams: { returnTo: window.location.origin } });
          setTokenExpired(true);
        }
      } catch (error) {
        console.error(`Handling token expiration failed due to ${error}`);
      }
    };

    if (isAuthenticated) {
      checkTokenExpiration();
    }
  }, [isAuthenticated, getAccessTokenSilently, logout]);

  return isTokenExpired;
};
